/**
 * Site JavaScript
 *
 * This file is bundled by esbuild and output to public/assets/js/main.js.
 * The base template includes it via <script src="/assets/js/main.js" defer>.
 *
 * Build:  pnpm run build
 * Watch:  pnpm run watch  (auto-rebuilds on change)
 */

// DOM ready helper
function ready(fn: () => void) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

const LOADING_LINES = [
  "Cross-referencing your answers against known behavioral data…",
  "Running deep personality diagnostics…",
  "Consulting the stars (they agree)…",
  "Finalizing verdict…",
];

function initVerdictMachine() {
  const form = document.getElementById("verdict-form") as HTMLFormElement | null;
  const nameInput = document.getElementById("q-name") as HTMLInputElement | null;
  const loading = document.getElementById("verdict-loading");
  const loadingLine = document.getElementById("loading-line");
  const result = document.getElementById("verdict-result");
  const resultName = document.getElementById("result-name");
  const certNumber = document.getElementById("cert-number");
  const certFootnote = document.getElementById("cert-footnote");
  const retryBtn = document.getElementById("retry-btn");
  const revealBtn = document.getElementById("verdict-reveal-btn");
  const verdictWord = document.getElementById("verdict-word");

  if (
    !form || !loading || !loadingLine || !result || !resultName || !certNumber ||
    !certFootnote || !retryBtn || !revealBtn || !verdictWord
  ) {
    return;
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    const name = (nameInput?.value || "").trim() || "Anonymous";

    form.classList.add("hidden");
    result.classList.add("hidden");
    loading.classList.remove("hidden");

    LOADING_LINES.forEach((line, index) => {
      setTimeout(() => {
        loadingLine.textContent = line;
      }, index * 700);
    });

    setTimeout(() => {
      resultName.textContent = name;
      certNumber.textContent = Math.floor(100000 + Math.random() * 900000).toString();
      loading.classList.add("hidden");
      result.classList.remove("hidden");
    }, LOADING_LINES.length * 700 + 400);
  });

  revealBtn.addEventListener("click", () => {
    verdictWord.classList.remove("hidden");
    certFootnote.classList.remove("hidden");
    revealBtn.classList.add("hidden");
  });

  retryBtn.addEventListener("click", () => {
    form.reset();
    result.classList.add("hidden");
    form.classList.remove("hidden");
    verdictWord.classList.add("hidden");
    certFootnote.classList.add("hidden");
    revealBtn.classList.remove("hidden");
  });
}

ready(() => {
  initVerdictMachine();
});
